<template>
  <section class="items-center">
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section--h3">Build your placement process with an intelligent HIRING interface</h3>
        <p class="section--p"><b>Portfolios, Personalities and Performance:</b> A smart-board listing structure that can easily be categorized, browsed and re-used. Layouts driven by the purpose of modularity.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Simple browsing of talent boards</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Infographic student portfolios with personality data</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Automated and optimized HR processes</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Unique 'Success Probability Score' for fitment</li>
        </ul>
      </vs-col>
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/university-df1.png" align="center"/>
      </vs-col>
    </vs-row>
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/university-df2.png" align="center"/>
      </vs-col>
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section--h3">Powerful analytics for guided decisions</h3>
        <p class="section--p"><b>Portfolios, Personalities and Performance:</b> A smart-board listing structure that can easily be categorized, browsed and re-used. Layouts driven by the purpose of modularity.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Simple browsing of talent boards</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Infographic student portfolios with personality data</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Automated and optimized HR processes</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Unique 'Success Probability Score' for fitment</li>
        </ul>
      </vs-col>
    </vs-row>
    <vs-row class="df-row mb-base" vs-type="flex" vs-justify="space-around">
      <vs-col class="df-col items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <h3 class="section--h3">Build your placement process with an intelligent HIRING interface</h3>
        <p class="section--p"><b>Portfolios, Personalities and Performance:</b> A smart-board listing structure that can easily be categorized, browsed and re-used. Layouts driven by the purpose of modularity.</p>
        <ul class="section_ul">
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Simple browsing of talent boards</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Infographic student portfolios with personality data</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Automated and optimized HR processes</li>
          <li class="mb-2"><vs-icon class="mr-3" color="#44CC88" icon="icon-check-circle" icon-pack="feather"/>Unique 'Success Probability Score' for fitment</li>
        </ul>
      </vs-col>
      <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-df-img" src="../../../../src/assets/images/demo/university-df3.png" align="center"/>
      </vs-col>
    </vs-row>
  </section>
</template>

<script>
    export default {
        name: "DetailedFeatures"
    }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }
  .df-row {
    margin: 0 0 10rem 0!important;
    width: 75%!important;
  }
  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: #231D4F;
  }
  .section__p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: #848199;
  }
  .section_ul li {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: center;
    flex-grow: 0;
    margin: 15px 0px;
    color: #848199;
  }
  .univ-df-img {
    width: 500px;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem;
      background: #FFFFFF;
    }
    .univ-df-img {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .df-row {
      margin-top: 0;
    }
    .df-col {
      margin-bottom: 5rem;
    }
  }
</style>
